import React from "react";
import "./styles/therapy.css";
import MEL6 from "../../assets/MEL.6.jpg";
import moss from "../../assets/moss.mp4";
import ServiceWarning from "../../components/ServiceWarning";

const Consultation = () => {
  return (
    <section className="therapy-section">
      <div className="therapy-card">
        <div className="video-banner">
          <video className="therapy-video" autoPlay muted loop playsInline>
            <source src={moss} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>

        <div className="therapy-content">
          <h1>Consultation Services for Service Providers</h1>
          <p>
            Consultation services are available for clinicians, agencies, or
            organizations seeking guidance on complex clinical cases. I tailor
            consultations to meet the specific needs of providers and teams,
            offering both case-specific input and a systems-level perspective.
          </p>
        </div>

        <div className="bottom-image-wrapper">
          <img
            src={MEL6}
            alt="Therapy session representation"
            className="therapy-image"
          />
        </div>
      </div>
      <ServiceWarning />
    </section>
  );
};

export default Consultation;
